import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { List } from 'linqts';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

import { UserService } from '../core/service/user.service';
import { LocalStorage } from '../core/helper/localStorage';
import { BaseComponent } from '../core/component/Base.Component';
import { AppConstants } from '../app.constant';
import { utConstants } from "../shell/ut/ut.constants";
import { ErrorComponent } from "../components/error/error.component";
import { errorArgs } from "../components/error/error.config";
import { GenEnum } from "../shell/shared/general.enum";

@Component({
    templateUrl: 'login.component.html',
    styleUrls: ['login.component.css']
})
export class LoginComponent extends BaseComponent {
    model: any = {};
    private instanceList = [];
    returnUrl: string;
    dto;
    @ViewChild("error") errorForm: ErrorComponent;

    constructor(private userService: UserService,
        private route: ActivatedRoute,
    ) {
        super();
        this.localStorage.clear();
    }

    async login() {

        this.dto = await this.userService.login(this.model.username, this.model.password);

        if (this.dto.IsSuccess) {
            this.localStorage.set('token', 'bearer '.concat(this.dto.Data.Session.token));
            const users = this.dto.Data.User;

            if (users && users.utuser)
                this.localStorage.set('userinfo', JSON.stringify(users.utuser))

            const username = users.username;
            const fullname = users.fullname;
            const userpic = users.userpic;
            const clients = users.utuserclients ? users.utuserclients : undefined;
            //const utuserents = users.utuserents;

            if (users && users.utuserents)
                this.localStorage.set('utuserents', JSON.stringify(users.utuserents))

            this.localStorage.set('Fullname', fullname);
            this.localStorage.set('User', username);
            if (userpic)
                this.localStorage.set('userpic', userpic);

            const clInfo = (new List<any>(clients)
                .Where(x => x.isdefault === true)
                .FirstOrDefault());
            if (clInfo) {
                const clientInfo = clInfo.utclient ? clInfo.utclient : undefined;
                if (clientInfo) {
                    this.localStorage.set('ClientStxt', clientInfo.clientstxt);
                    this.localStorage.set('ClientCode', clientInfo.clientcode);
                }
                this.localStorage.set('userclients', JSON.stringify(clients));
            }
            if (this.dto && this.dto.Data && this.dto.Data.Apps) {
                var appInfo;
                if (this.dto.Data.Apps.length === 1)
                    appInfo = (new List<any>(this.dto.Data.Apps).FirstOrDefault());
                else
                    appInfo = (new List<any>(this.dto.Data.Apps)
                        .FirstOrDefault(x => x.appcode === AppConstants.settings.appCode));

                if (appInfo) {
                    
                    const instanceInfo = (new List<any>(appInfo.utdatabase.utinstances).FirstOrDefault(
                        x => x.instanceid === AppConstants.settings.instanceid));
                    
                    if (instanceInfo) {
                        
                        this.localStorage.set('apiUrl', instanceInfo.apiurl + 'api/');
                        this.localStorage.set('OnlyUrl', instanceInfo.apiurl);

                        this.errorForm.showErrors('Logged in successfully', 'Authenticated', GenEnum.ErrorTypes.Success, 2);
                        this.navigate("home");
                    } else {
                        
                        this.errorForm.showErrors('Instance does not exist.');
                    }
                }
                else {
                    this.errorForm.showErrors('User is not assigned this application.');
                }
            } else {
                this.errorForm.showErrors("User is not assigned this application.");
            }
        }
        else {
            this.errorForm.showErrors(this.dto.Errors);
        }

    }

    // confirm(value: errorArgs) {
    //     
    //     if (value.value === 1 && value.type === GenEnum.ErrorTypes.Success) {
    //         this.navigate("home");
    //     }
    // }
}




// WEBPACK FOOTER //
// ./src/app/login/login.component.ts